// removed by extract-text-webpack-plugin
module.exports = {"exit":"exit__exit___3MO1g"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/icons/exit.css
// module id = 861
// module chunks = 0